import axios from 'axios';

export const validateNRIC = (nricNo,sessionId) => (axios({
    method: 'post',
    url: '/api/accounts/validateIdNo',
    data: {
        "lastFourDigitId": nricNo,
        "sessionId": sessionId
    },
    headers: {'Content-Type': 'application/json'}
}));

